var _defs, _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg73Delete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.02,5.62h3.95c.55,0,1,.45,1,1v.51H5.02v-.51c0-.55,.45-1,1-1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.97,
    y: 4,
    width: 2.05,
    height: 0.81,
    rx: 0.4,
    ry: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.38,7.94v3.58c0,.26,.24,.48,.53,.48h4.19c.29,0,.53-.21,.53-.48v-3.58H5.38Zm1.28,3.17c0,.16-.13,.28-.28,.28s-.28-.13-.28-.28v-2.27c0-.16,.13-.28,.28-.28s.28,.13,.28,.28v2.27Zm1.62,0c0,.16-.13,.28-.28,.28s-.28-.13-.28-.28v-2.27c0-.16,.13-.28,.28-.28s.28,.13,.28,.28v2.27Zm1.62,0c0,.16-.13,.28-.28,.28s-.28-.13-.28-.28v-2.27c0-.16,.13-.28,.28-.28s.28,.13,.28,.28v2.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg73Delete);
export default __webpack_public_path__ + "static/media/73-delete.6098132ce87e326876f9b35ba291c2eb.svg";
export { ForwardRef as ReactComponent };